module.exports = __webpack_public_path__ + "static/media/1B.8b01d78f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/Files/1B.pdf
// module id = 78
// module chunks = 0